import React from "react";
import { Helmet } from "react-helmet";

import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import HeaderThree from "../../../components/header/HeaderThree";
import FancyTextBlockThree from "../../../components/fancy-text-block/FancyTextBlockThree";
import AboutTabs from "../../../components/block-slider/AboutTabs";
import FancyFeatureTewentyTwo from "../../../components/features/FancyFeatureTewentyTwo";
import Banner from "../../../assets/Sub-component/Banner";
import { Link } from "react-router-dom";


import Customized_Training_Modules from '../../../assets/Services/Cogni/Keyfeature/Customized_Training_Modules.svg'
import Data from '../../../assets/Services/Cogni/Keyfeature/Data-Driven_Progress_Tracking.svg'
import Supportive_Community from '../../../assets/Services/Cogni/Keyfeature/Supportive_Community.svg'
import Immersive_VR_Environment from '../../../assets/Services/Cogni/Keyfeature/Immersive_VR_Environment.svg'
import Realistic_Social_Scenarios from '../../../assets/Services/Cogni/Keyfeature/Realistic_Social_Scenarios.svg'
import User_friendly from '../../../assets/Services/Cogni/Keyfeature/User-Friendly_Interface.svg'

import Classroom_Social from '../../../assets/Services/Cogni/Life_skills/Classroom_Social.svg'
import Gestures from '../../../assets/Services/Cogni/Life_skills/Gestures.svg'
import Gestures2 from '../../../assets/Services/Cogni/Life_skills/Gestures2.svg'
import Imitation from '../../../assets/Services/Cogni/Life_skills/Imitation.svg'
import Join_Attention from '../../../assets/Services/Cogni/Life_skills/Join_Attention.svg'
import Mindful_Thinking from '../../../assets/Services/Cogni/Life_skills/Mindful_Thinking.svg'
import School_Hallway from '../../../assets/Services/Cogni/Life_skills/School_Hallway.svg'
import Street_Crossing from '../../../assets/Services/Cogni/Life_skills/Street_Crossing.svg'
import launchingimage from '../../../assets/Launchingimage.png'

const RaidenCogni = () => {
  const banner = [
    {
      title: "Curious about what it's like to work here?",
      desc: "A group of skilled developers has been brought together to maximize the efficiency of your business, so prepare to release an application.",
      title2: "Curious about what it's like to work here?",
    },
  ];

  const benefits = [
    {
      name: "Support ",
      value:
        " Become the best version of yourself by continuously adjusting to social situations while feeling empowered and capable.",
      name2: " social skills",
      value2:
        " Strengthen your public speaking abilities by continuously practicing in our controlled environment.",
      name3: "Reduced Anxiety",
      value3:
        "Overcome your anxiety related to awkward social situations by adapting to decentralization and interaction techniques",
    },
  ];
  const FeatureContent = [
    {
      icon:  Join_Attention,
      title: "Joint Attention",
      subTitle: `Cultivate joint attention for social interactions on shared activities or objects, and build connections`,
      bgColor: "#FF4A8B",
    },
    {
      icon: Imitation,
      title: "Imitation",
      subTitle: `Mimicry, expressions, and actions to improve your social learning and communication skills.`,
      bgColor: "#6D49FF",
    },
    {
      icon: Street_Crossing,
      title: "Street Crossing",
      subTitle: `Developing your traffic awareness skills will make crossing the street less stressful and more secure.`,
      bgColor: "#FFB951",
    },
    {
      icon: School_Hallway,
      title: "School Hallway",
      subTitle: `Congested corridors involve being aware of your surroundings, following navigation rules, and interacting socially.`,
      bgColor: "#FF4A8B",
    },
    {
      icon:Gestures2,
      title: "Hallway Small Talk",
      subTitle: `Encourage small talk and brief interactions to connect with teachers and peers using effective conversational strategies.`,
      bgColor: "#6D49FF",
    },
    {
      icon: Gestures,
      title: "Gestures",
      subTitle: `Learn gestures to express ideas and emotions nonverbally.`,
      bgColor: "#FFB951",
    },
    {
      icon: '',
      title: "Cafeteria Social Skills",
      subTitle: `Boost your public speaking in cafeterias with inclusive behavior and good table manners.`,
      bgColor: "#FF4A8B",
    },
    {
      icon: Mindful_Thinking,
      title: "Mindful Thinking",
      subTitle: `A productive mind boosts self-awareness and confidence. Explore mindful practices for resilience and focus.`,
      bgColor: "#6D49FF",
    },
    {
      icon:Classroom_Social,
      title: "Classroom Social",
      subTitle: `Cultivate classroom skills like active listening and collaboration for better learning and success.`,
      bgColor: "#FFB951",
    },
  ];

  const keyfeature = [
    {
      name: "Immersive VR Environment",
      icon:Immersive_VR_Environment,
      description:
        "We encourage you to engage in adventurous interaction, rather than simply following instructions, in a safe environment where you can practice various social situations.",
      // icon: "",
      name2: "Customized Training Modules",
      description2:
        "Our training modules cover everything from basic social interactions to engaging communication strategies that can be customized to meet specific goals and abilities.",
      icon2: Customized_Training_Modules,
      name3: "Realistic Social Scenarios ",
      description3: "Engage with the everyday routines, such as conversation initiation, facial expression interpretation, and social cue navigation, to help users improve their skills with these interactive scenarios. ",
      icon3: Realistic_Social_Scenarios,
      name4: " Data-Driven Progress Tracking",
      description4:
        "We integrate data tracking tools with your system by providing user engagement insights, focus guidance, and lasting updates.",
      icon4: Data,
      name5: "User-Friendly Interface",
      description5:
        "  Our intuitive interface facilitates participation and offers the control, skill level, and unambiguous instructions that are useful for independent learning and exploration.",
      icon5: User_friendly,
      name6: " Supportive Community ",
      description6: "Connect and engage across the community of users and professionals for autism advocacy, sharing experiences, exchanging tips, and celebrating milestones.  ",
      icon6: Supportive_Community,
    },
  ];
  return (
    <>
        <img className="Bg-image z-0"
      src={launchingimage} 
      
      alt="Launching"
    />
    <div className=" overflow-hidden  ">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>

      <HeaderThree />

      <div className="bg-white ">
        <div
          className=" container z-10 position-relative  d-flex align-items-center justify-content-center flex-column "
          style={{ minHeight: "100vh" }}
        >
          <h1 className="h1-heading fw-bold text-center">Raiden COGNI+</h1>
          <h2 className="my-2 h2-heading">
            {" "}
            Enriching with Raiden Cogni+: Autism Training in VR
          </h2>
          <p className="h1-para text-center mt-4 mb-4">
            Raiden Cogni+ makes people's lives better by offering immersive VR
            autism training in a safe environment.
          </p>
           <Link to="/request-quote">
          <button
            className="h3-para btn btn-primary mt-3 py-3 px-3 btn-gradient border-0  rounded-4"
            style={{ fontSize: 18 }}
            >
            Get Your Free Quote
          </button>
            </Link>
        </div>
      </div>
      <div className=" bg-light">
        <div className=" container pt-50  ">
          <div className=" row ">
            <h2 className="h2-heading text-center text-lg-start col-12 col-lg-6  ">
              {" "}
              Raiden Cogni+{" "}
            </h2>
            <p className="h3-para col-12 col-lg-6 mt-2 mt-lg-0">
              People with autism spectrum disorder (ASD) can better understand
              and manage their condition with the help of COGNI+, an innovative
              virtual reality (VR) autism training solution. We use virtual
              reality to deliver sessions that encourage children to participate
              more naturally than when they attend lectures. This improves their
              responses, behavior, interpersonal interactions, and communication
              abilities.
            </p>
          </div>
        </div>

        {/* Key Features */}
        <div className="fancy-text-block-three bg-light mt-80 mart">
          <div className="container">
            <h2 className="text-center h2-heading mb-3 pb-lg-3">
              Key Features—COGNI+
            </h2>
            <div className="row">
              <div className="col-xl-11 m-auto">
                <FancyTextBlockThree keyfeature={keyfeature[0]} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-black">
        <div className=" container  pt-80 padt pb-80 padb">
          <div className=" row ">
            <h2 className="h2-heading text-center  text-white text-lg-start col-12 col-lg-6  ">
              {" "}
What COGNI+ Benefits             </h2>
            <p className="h3-para col-12 col-lg-6 mt-2 mt-lg-0 text-white opacity-75">
             The Virtual Reality (VR) Autism Training Solution from COGNI+ welcomes the future by enabling people with ASD to participate and benefit from training. We put them in a world where they can practice social skills, communication abilities, and behavioral responses less frequently. This allows them to develop critical life skills in a controlled environment.


            </p>
          </div>
        </div>
      </div>

      {/* Who Stands to Gain  */}
      <div className="fancy-text-block-twenty pt-80 padt pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="">
                <h2 className="h2-heading text-center text-lg-start mb-2 mb-lg-0">
                  Benefits of COGNI+
                </h2>
              </div>
            </div>
            <div className="col-lg-6 ms-auto">
              <AboutTabs benefits={benefits[0]} />
            </div>
          </div>
        </div>
      </div>

      {/* Raiden's Core  */}
      <div className="fancy-feature-twentyTwo mt-200 md-mt-120">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 col-md-8 m-auto">
              <div className=" text-center ">
                <h2 className="h2-heading mb-md-3 mb-2">
                Developing Practical Life Skills
                </h2>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <FancyFeatureTewentyTwo FeatureContent={FeatureContent} />
          </div>
        </div>
      </div>

      <div className="border-y-div m-0">
        <Banner banner={banner} />
      </div>

      {/* footer */}
      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
    </>
    
  );
};

export default RaidenCogni;
